import React, { Suspense } from "react";
import { Spin } from "antd";
import { useParams } from "react-router-dom";
const LevelsContainer = React.lazy(
  () => import("../../../../modules/Gamification/components/levels")
);

const LevelsPage = () => {
  const params = useParams<{ gamificationId: string; pointGameId: string }>();

  return (
    <Suspense fallback={<Spin />}>
      <LevelsContainer
        gamificationId={params.gamificationId}
        pointGameId={params.pointGameId}
      />
    </Suspense>
  );
};

export default LevelsPage;
